import React from "react";
import { ServiceOneItem } from "./ServiceOneItem";
import { getServices } from "../../data/services";
import { useTranslation } from "react-i18next";

export const ServiceFive = () => {
  const { t } = useTranslation();
  const services = getServices(t);

  return (
    <section className="services-area-five inner-services-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8 col-md-10">
            <div className="section-title-two text-center mb-50">
              <h2 className="title">{t("servicesPage.title")}</h2>
              <p>{t("servicesPage.text")}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {services.map((service) => (
            <div key={service.id} className="col-lg-4 col-md-6 col-sm-10">
              <ServiceOneItem service={service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
